import { useEffect } from "react";
import AppRouter from "./routes/AppRouter";
import db from './db/lectureCacheDB';
import { isCacheExpired } from './db/cacheConfig'; // import 사용

const App = () => {
  useEffect(() => {
    const cleanupExpiredCaches = async () => {
      try {
        const allCaches = await db.translations.toArray();

        for (const cache of allCaches) {
          // import한 isCacheExpired 함수 사용
          if (isCacheExpired(cache.savedAt, cache.ttl)) {
            await db.translations.delete(cache.filterKey);
            await db.lastTimestamps.delete(cache.filterKey);
          }
        }
      } catch (error) {
        console.warn('[Cache] 정리 실패:', error);
      }
    };

    cleanupExpiredCaches();
  }, []);

  return <AppRouter />;
};

export default App;